export default __webpack_public_path__ + "static/media/userpic7.8dc51a58.svg";